<template>

    <div class="container vh-100 d-flex justify-content-sm-center align-items-sm-center">

        <div class="row">
            <div class="col-12 col-sm-7 order-1 order-sm-2 p-0">
                <img src="/assets/images/mm_logo_white.png" alt="..." class="w-100 avatar">
            </div>
            <div class="col-12 col-sm-5 offset-sm-0 order-2 order-sm-1 bg-light text-dark bg-gradient p-5 d-sm-flex justify-content-sm-center align-items-sm-center">

                <main class="form-signin">
                    <form class="text-center">
                        <!-- <img class="mb-4" src="assets/images/logo.jpg" alt="" width="150" /> -->
                        <h1 class="h3 mb-0 fw-normal">GİRİŞ</h1>
                        <h1 class="h6 mb-5 fw-normal text-info">Lorem Ipsum Dolor</h1>
                        <div class="mb-2">
                            <div v-if="loginError" class="text-danger text-wrap">
                                Daxil etdiyiniz email və ya şifrə yanlışdır !
                            </div>
                            <div v-else>&nbsp;</div>
                        </div>

                        <div class="form-floating">
                            <input
                            type="email"
                            class="form-control border-0 border-bottom border-secondary bg-transparent text-dark mb-21"
                            id="floatingInput"
                            autocomplete="off"
                            placeholder=""
                            v-model="email"
                            @keyup.enter="auth"
                            />
                            <label for="floatingInput">Email</label>
                        </div>
                        <div class="form-floating">
                            <input
                            type="password"
                            class="form-control border-0 border-bottom border-secondary bg-transparent text-dark"
                            id="floatingPassword"
                            autocomplete="off"
                            placeholder=""
                            v-model="password"
                            @keyup.enter="auth"
                            />
                            <label for="floatingPassword">Şifrə</label>
                        </div>

                        <div class="checkbox my-4">
                            <label class="cursor-pointer">
                                <input type="checkbox" value="xatirla" class="me-1" /> Məni xatırla
                            </label>
                        </div>
                        <button class="w-100 btn btn-lg btn-secondary border-0" type="button" @click="auth">
                            Daxil ol
                        </button>
                        <p class="mt-5 mb-3 text-muted1" v-html="footerInfo"></p>
                    </form>
                </main>

            </div>
        </div>

    </div>

</template>

<script>
    import { onMounted, ref } from "vue";

    import { useRouter } from "vue-router";
    import { G } from "@/_common";

    export default {
        setup() {
            const email = ref("");
            const password = ref("");
            const loginError = ref(false);
            const footerInfo = G.footerPowered;

            const router = useRouter();

            onMounted(() => {
                G.removeClientData("DA_AUTH_TOKEN");
            });

            const auth = async (e) => {
                e.preventDefault();
                let loginData = new FormData();
                loginData.append("email", email.value);
                loginData.append("password", password.value);

                router.push("/");

                // await ajax
                //     // .post(`employee/auth`, JSON.stringify({"email": email.value, "password": password.value}), {
                //     .post(`login/`, loginData, {})
                //     .then((e) => {
                //         let res = e.data || null;
                //         if (res && res.token && res.token.length > 0) {
                //             G.token = res.token;
                //             G.setClientData("DA_AUTH_TOKEN", res.token);
                //             router.push("/");
                //         } else {
                //             G.removeClientData("DA_AUTH_TOKEN");
                //         }
                //     })
                //     .catch((error) => {
                //         var res = error.response || {};
                //         if (res.status == 401) console.log(res.data.msg);
                //         // else console.log(error.response);
                //         loginError.value = true;

                //         G.removeClientData("DA_AUTH_TOKEN");
                //     });
            };

            return { email, password, loginError, auth, footerInfo };
        },
    };
</script>

<style lang="scss">

.login-image-info{
    // background-image: url('https://meclis.gov.az/photos/1 esas_1640194571.JPG');
    width: 500px;
    background-size: cover;
    -o-object-fit: cover;
    object-fit: cover;
    display: inline-block;
}
.avatar{
    object-fit: cover;
    height: 100%;
}

.bg-light{
    // background-color: rgba(189, 189, 189, .3) !important;
}
.form-signin {
    width: 100%;
}
.form-signin input {
    background: transparent;
    border-radius: 0;
}
</style>